import {z} from 'zod';

export const scanVINResponseSchema = z.object({
  vin: z.string().nullable(),
});

export type ScanVINResponse = z.infer<typeof scanVINResponseSchema>;
